import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/gameConfig';

export default class Obstacle extends Phaser.Physics.Arcade.Sprite {
  public radius: number;
  private lifetime: number; // 生存時間（秒）
  private elapsedTime: number = 0; // 経過時間（秒）

  constructor(scene: Phaser.Scene, x: number, y: number) {
    // 画像を使用しておじゃまキャラを作成
    super(scene, x, y, 'dog');

    this.lifetime = GAME_CONFIG.obstacle.lifetime;
    this.elapsedTime = 0;

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.setOrigin(0.5, 0.5);

    // 画像をリサイズせずそのまま使用
    // 画像の実際のサイズを取得
    const displayW = this.displayWidth;
    const displayH = this.displayHeight;
    const r = GAME_CONFIG.obstacle.radius; // コライダー半径は現状維持（40）
    
    this.radius = r; // 半径を設定

    const body = this.body as Phaser.Physics.Arcade.Body;

    // 動かないおじゃまキャラにする
    body.setAllowGravity(false);
    body.setImmovable(true);
    body.setVelocity(0, 0);

    // 円のコライダーを設定
    body.setCircle(r);
    body.setSize(displayW, displayH);
    body.setCircle(r);
    body.setOffset(0, 0);
    body.enable = true;

    // おじゃまキャラのdepthをエネルギーの後ろに設定
    this.setDepth(20);
    
    // おじゃまキャラの明るさを固定（電球のライトエフェクトの影響を受けないようにする）
    this.setAlpha(1);
    this.clearTint();
  }

  update(delta: number): void {
    // 経過時間を更新（deltaはミリ秒なので秒に変換）
    this.elapsedTime += delta / 1000;
    
    // 生存時間を超えたら削除の準備（実際の削除はPlaySceneで行う）
    if (this.elapsedTime >= this.lifetime) {
      // フェードアウト効果（オプション）
      const remainingTime = this.lifetime - this.elapsedTime;
      if (remainingTime < 0.5) {
        // 最後の0.5秒でフェードアウト
        this.setAlpha(Math.max(0, remainingTime / 0.5));
      }
    }
  }
  
  /**
   * 生存時間を超えているかどうかを取得
   */
  isExpired(): boolean {
    return this.elapsedTime >= this.lifetime;
  }

  destroy(): void {
    super.destroy();
  }
}

